<div fxLayout="row wrap" fxLayoutAlign="center" [@animateStagger]="{value:'50'}">

  <mat-tab-group style="width: 100%; background: white;padding-bottom: 60px;" (selectedTabChange)="sendBroadcast($event)">
    <mat-tab label="{{'CERTIFICAR.FORALL.TABLA.TITULOS.DEFAULT' | translate}}">
  	<!-- <div class="mat-app-background basic-container">
    		<native style="display:flex;"
        [pasoCompleto]="pasoCompleto"
        ></native>
    	</div> -->
      <native
        [pasoCompleto]="pasoCompleto"
        (formValido)="formvalido($event)"
        (actualizaTraducciones)="getNumTraducciones($event)"
      ></native>
    </mat-tab>
    <mat-tab *ngIf="numArrayTraduc > 0" label="{{'CERTIFICAR.FORALL.TABLA.TITULOS.TRADUCCION' | translate}}" style="height: 100%;">
    	<translate [pasoCompleto]="pasoCompleto"></translate>
    </mat-tab>
    <mat-tab label="{{'CERTIFICAR.FORALL.TABLA.TITULOS.PREVIEW' | translate}}">
    	<preview></preview>
    </mat-tab>
  </mat-tab-group>

  <!-----------boton finalizar paso---------->
  <div fxLayout="row" fxLayoutAlign="end end" class="mb-20 finishBt">
    <button *ngIf="!pasoCompleto" (click)="completarPaso()" mat-fab aria-label="boton completar paso"
      matTooltip="{{'CERTIFICAR.FORALL.STATUS.PEND' | translate}}" matTooltipPosition="left" class="undone mr-20"
      (click)="completarPaso()"
    >
      <mat-icon>done</mat-icon>
    </button>
    <button *ngIf="pasoCompleto" (click)="completarPaso()" mat-raised-button class="done mr-20">
      {{'CERTIFICAR.FORALL.STATUS.DONE' | translate}}
      <mat-icon class="ml-20">done</mat-icon>
    </button>
  </div>
</div>
